import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { ResolveDocumentShareLink } from '../redux/documentsSlice';
import { setActiveWorkspaceId, setWorkspaceSelectionRequired } from '../redux/usersSlice';
import { GetCurrentProjectData } from '../redux/projectDataSlice';

const SharedDocumentPage = () => {
    const { shareId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const activeWorkspaceId = useSelector(state => state?.user?.activeWorkspaceId) || localStorage.getItem('active_workspace_id');

    React.useEffect(() => {
        if (!shareId) return;

        const state = location.state || {};
        const fallbackPath = state.fallbackPath;

        dispatch(ResolveDocumentShareLink(shareId))
            .unwrap()
            .then(doc => {
                // 1. Set workspace + project context (clear workspace picker requirement so we aren't sent to select-workspace)
                if (doc?.workspace_id) {
                    dispatch(setActiveWorkspaceId(doc.workspace_id));
                }
                dispatch(setWorkspaceSelectionRequired(false));
                if (doc?.project_id) {
                    localStorage.setItem('project_id', doc.project_id);
                    dispatch(GetCurrentProjectData());
                }

                // 2. Navigate into dataroom with context so it can auto-open the file
                navigate('/dataroom', {
                    replace: true,
                    state: {
                        fromSharedLink: true,
                        workstreamId: doc.workstream_id,
                        folderId: doc.ws_folder_id,
                        document: doc,
                        fallbackPath,
                    },
                });
            })
            .catch(() => {
                toast.error('You do not have access');
                if (!activeWorkspaceId) {
                    navigate('/select-workspace', { replace: true });
                } else {
                    navigate('/project', { replace: true });
                }
            });
    }, [shareId, dispatch, location.state, navigate, activeWorkspaceId]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                gap: '1rem',
            }}>
            <AiOutlineLoading3Quarters className="rotateLoader" style={{ fontSize: '2.5rem', color: 'var(--Brand-Primary)' }} />
            <p style={{ margin: 0, color: 'var(--text-secondary)' }}>Verifying link…</p>
        </div>
    );
};

export default SharedDocumentPage;
